module.exports = __webpack_public_path__ + "media/images/salary-c02e8db326d5ce42bb584fcbf1236564.svg";